//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useContext, useState, useCallback, useEffect } from 'react';
import {
    Grid,
    Menu,
    MenuItem,
    // InputBase,
    Popover,
    // InputAdornment,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
// import SearchIcon from '@material-ui/icons/Search';
import { useHistory, useLocation } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
// import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';

import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import {
    PATH_HOME,
    PATH_RESOURCE_CENTER,
    PATH_SUB_PAGE_TERMS,
    PATH_SUB_PAGE_PRIVACY,
    // PATH_EMP_SEARCH,
    PATH_SURVEY,
    PATH_JOIN_INTERVIEW,
    PATH_JOIN_INTERVIEW_TEST_JOIN_CODE,
    PRE_LAUNCH_PAGE,
    PATH_ADMIN_CONSOLE,
    PATH_ADVERTISE,
} from '../../system/constants';
import {
    ADMIN_ID_JOB_SEEKER,
    BASE_URL,
    HOMEPAGE_FAQ,
    // SEARCH
} from '../../common/constants';
import { AppContext, LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getFullNameMiddleInitialByUser } from '../../common/textHelper';
import { PLACEHOLDER_SEARCH_EMPLOYERS } from '../../common/placeholderHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
// import { isOnPage } from '../../system/helpers/systemHelper';
import TopNavJsSmallMenu from './TopNavJsSmallMenu';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import Logo from '../../system/Logo';
import LogoSm from '../../system/LogoSm';
import AfitdBox from '../../common/elemental/AfitdBox';
import AfitdAvatarWithRing from '../../common/elemental/AfitdAvatarWithRing';
import AfitdButton from '../../common/elemental/AfitdButton';
// import AfitdIconButton from '../../common/elemental/AfitdIconButton';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';
import TopNavButton from './TopNavButton';
import DashboardPopover from './DashboardPopover';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';

// const alpha = () => {};

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const drawerWidth = '100%';
const useStyles = (params = {}) => {
    const nonFirstButtonContainerStyles = { marginLeft: '40px' };

    return makeStyles(theme => ({
        topNavContainer: {
            overflow: 'hidden',
            overflowX: 'hidden',
            paddingRight: '64px',
            background: '#FAFAFC',
            width: '100%',
            height: '80px',
            borderBottom: '1px solid #F0F2F6',
            [theme.breakpoints.down('sm')]: { paddingRight: 0 },
        },
        // topNavLeft: { [theme.breakpoints.down('sm')]: { borderBottom: '1px solid #F0F2F6', height: 80 } },
        topNavRight: { height: '100%' },
        appLogoContainer: {
            // width: '368px',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            [theme.breakpoints.up('xl')]: { width: '368px' },
            [theme.breakpoints.down('sm')]: { borderBottom: '1px solid #F0F2F6', height: 80 },
        },
        appLogoHomeLink: { marginTop: 10, [theme.breakpoints.down('md')]: { marginTop: 6 } },
        // appLogo: { width: 165 },
        appLogoClose: { width: 180 },
        topNavRightContainer: {
            background: '#FAFAFC',
            width: '100%',
            height: '80px',
            borderBottom: '1px solid #F0F2F6',
            display: 'flex',
            flexDirection: 'row',
        },

        // leftContainer: {
        //     width: '368px',
        //     display: 'flex',
        //     alignItems: 'center',
        //     justifyContent: 'center',
        // },
        // rightContainer: {
        //     display: 'flex',
        //     flexDirection: 'row',
        // },

        searchIcon: { cursor: 'pointer' },
        searchInput: { cursor: 'pointer' },

        resourceCenterButtonContainer: { ...nonFirstButtonContainerStyles },
        // dashboardButtonContainer: { ...nonFirstButtonContainerStyles, [theme.breakpoints.down('md')]: { margin: 'auto', marginLeft: '34px' } },
        tempMenuButtonContainer: { ...nonFirstButtonContainerStyles, [theme.breakpoints.down('md')]: { margin: 'auto', marginLeft: '40px' } },
        avatarContainer: {
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginLeft: '40px',
            [theme.breakpoints.down('sm')]: { marginRight: 12, marginLeft: '8px' },
        },
        // appLogo: {
        //     width: 165,
        // },
        avatar: {
            cursor: 'pointer',
        },
        avatarPopover: {
            // cursor: 'pointer',
        },
        empSearchContainer: {
            // padding: 10,
            // backgroundColor: 'rgba(240, 242, 246, 1)',
            // '&:hover': {
            //     backgroundColor: 'rgba(240, 242, 246, 1)',
            // },
            margin: 'auto',
            [theme.breakpoints.only('md')]: { maxWidth: 260 },
            // [theme.breakpoints.down('sm')]: { maxWidth: 152 },
        },
        // drawer style
        root: {
            display: 'flex',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
        },
        drawerPaper: {
            width: drawerWidth,
            marginTop: 78,
            background: 'white',
            borderTop: '1px solid #F0F2F6',
        },
        drawerHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(0, 1),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
            justifyContent: 'flex-end',
        },
        logoDrawerContainer: {
            display: 'flex',
            alignItems: 'center',
            // justifyContent: 'space-evenly',
            height: '100%',
            alignContent: 'center',
            marginLeft: 38,
            [theme.breakpoints.down('sm')]: { marginLeft: 15 },
        },
        logoDrawerCloseContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: '100%',
            alignContent: 'center',
            marginLeft: 58,
            [theme.breakpoints.down('sm')]: { marginLeft: 10 },
        },
        drawerIconContainer: { display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 12 },
        dashboardContent: {
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            paddingRight: '64px',
            [theme.breakpoints.down('md')]: { paddingRight: '0px', justifyContent: 'center' },
        },
        topNavBottomContainer: {
            background: '#FAFAFC',
            width: '100%',
            height: '40px',
            borderBottom: '1px solid #F0F2F6',
            display: 'flex',
            flexDirection: 'row',
            [theme.breakpoints.down('sm')]: { justifyContent: 'center', alignItems: 'center' },
        },
        // popover style
        profilePopOverContainer: { width: 340, [theme.breakpoints.down('xs')]: { width: '280px' } },
        closeIconContainerProfile: { textAlign: 'right', marginTop: 20, marginRight: 20, color: 'rgba(17, 30, 20, 0.4)' },
        closeIconContent: { cursor: 'pointer' },
        profileImage: { textAlign: 'center', marginTop: '-26px', display: 'flex', justifyContent: 'center', alignItems: 'center' },
        popoverContents: { textAlign: 'center' },
        fullNameText: { fontSize: 20, fontWeight: 'bold', paddingTop: 10 },
        isAdminText: { fontSize: 18, fontWeight: 'bold', paddingTop: 5 },
        emailText: { fontSize: 16, paddingTop: 5, color: 'rgba(17, 30, 20, 0.6)' },
        manageAccountBtn: { marginTop: 10 },
        logOutBtn: { marginTop: 15, marginBottom: 15 },
        privacyAndTermsText: { color: 'rgba(17, 30, 20, 0.6)', marginBottom: 20 },
        termsOfUseLink: {
            cursor: 'pointer',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        privacyLink: {
            cursor: 'pointer',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        notificationBadgeContainer: {
            background: '#fc821f',
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            lineHeight: '24px',
            cursor: 'pointer',
            marginRight: 12,
        },
        notificationBadge: {
            fontSize: '13px',
            color: '#ffffff',
            fontWeight: 'bold',
        },
        notificationBadgeContainerClose: {
            background: '#fc821f',
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            lineHeight: '24px',
            marginLeft: '-36px',
            cursor: 'pointer',
        },
        //search box style
        searchContainer: {
            position: 'relative',
            borderRadius: theme.shape.borderRadius,
            backgroundColor: 'rgba(240, 242, 246, 1)',
            '&:hover': {
                backgroundColor: 'rgba(240, 242, 246, 1)',
            },
            marginLeft: 0,
            width: '100%',
            minWidth: 170,
            height: 50,
            [theme.breakpoints.up('md')]: {
                marginLeft: 12,
                // width: 'auto',
            },
            marginRight: 10,
            [theme.breakpoints.up('xl')]: { marginLeft: 8 },
        },
        searchBoxIcon: {
            marginTop: 8,
            marginLeft: 10,
            color: 'rgba(155, 158, 156, 1)',
        },
        searchIconBtn: {
            [theme.breakpoints.down('sm')]: {
                padding: 0,
            },
        },
        inputRoot: {
            color: '#222222',
        },
        inputInput: {
            padding: '16px 8px 8px 8px',
            transition: theme.transitions.create('width'),
            width: '100%',
            cursor: 'pointer',

            [theme.breakpoints.down('sm')]: {
                '&::placeholder': {
                    fontSize: '15px',
                },
            },
        },
        test: {
            color: 'red',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        // props,
        classes,
        appContext,
        handleClickLogo,
        handleClickProfilePic,
        // handleClickPopoverProfilePic,
        history,
        // setPendingAccountSetupMessageDialogOpen,
        location,
    } = params;
    const currentPath = location.pathname.slice(1, 16);
    const { emailVerified, pendingAccountSetup, setPendingAccountSetupMessageDialogOpen } = appContext;

    const profilePicUrl = _get(appContext, 'currentUser.profilePicUrl');

    const preAccountSetup = !emailVerified || pendingAccountSetup;

    const defns = {
        topNavContainer: { container: true },
        topNavLeft: { item: true, lg: 3, md: 3, sm: 3, xs: 3 },
        topNavRight: { item: true, lg: 9, md: 9, sm: 9, xs: 9 },
        topNavBottomRight: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        // appLogoContainer: { onClick: handleClickLogo },
        appLogoHomeLink: { onClick: handleClickLogo },
        empSearchBox: { placeholder: PLACEHOLDER_SEARCH_EMPLOYERS },
        resourceCenterButton: {
            onClick: handleClickResourceCenterButton.bind(null, history, preAccountSetup, setPendingAccountSetupMessageDialogOpen),
            label: 'Resource Center',
            isSelected: currentPath === 'resource-center' ? true : false,
        },
        dashboardButton: {
            // onClick: handleClickButton.bind(null, history, PATH_DASHBOARD),
            label: 'My Dashboard',
        },
        avatar: {
            photoSize: 40,
            borderSize: 3,
            // placeholderFontSize: 15,
            src: profilePicUrl,
            onClick: handleClickProfilePic,
        },
        avatarPopover: {
            photoSize: 90,
            borderSize: 4,
            placeholderFontSize: 30,
            src: profilePicUrl,
            // onClick: handleClickPopoverProfilePic,
            // [theme.breakpoints.down('md')]: { width: 90, height: 90 },
        },
        termsOfUseLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_TERMS}`),
        },
        privacyLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_PRIVACY}`),
        },
        dashboardContent: { item: true, container: true },
        dashboardLeft: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const handleClickResourceCenterButton = (history, preAccountSetup, setPendingAccountSetupMessageDialogOpen) => {
    if (preAccountSetup) {
        setPendingAccountSetupMessageDialogOpen(true);
    } else {
        history.push(`${BASE_URL}${PATH_RESOURCE_CENTER}`);
    }
};

const handleClickButton = (history, path) => {
    history.push(`${BASE_URL}${path}`);
};

// const SearchBox = props => {
//     // const classes = useStyles();
//     const classes = useStyles(/*{param1, param2}*/)();
//     const appContext = useContext(AppContext);
//     const { emailVerified, pendingAccountSetup, setPendingAccountSetupMessageDialogOpen } = appContext;
//     const history = useHistory();

//     const [searchText] = useState();

//     const { placeholder = `${SEARCH}...` } = props;

//     // const handleChangeSearchBox = evt => {
//     //     const value = _get(evt, 'target.value');
//     //     setSearchString(value);
//     // };

//     // const handlePressKey = evt => {
//     //     if (evt.key === 'Enter') {
//     //         showEmployerSearchPage();
//     //     }
//     // };

//     const handleClickSearchBox = evt => {
//         if (!emailVerified || pendingAccountSetup) {
//             setPendingAccountSetupMessageDialogOpen(true);
//         } else {
//             const el = evt.target;
//             el.blur();
//             showEmployerSearchPage();
//         }
//     };

//     // const handleClickSearchIcon = evt => {
//     //     showEmployerSearchPage();
//     // };

//     const showEmployerSearchPage = () => {
//         history.push(`${BASE_URL}${PATH_EMP_SEARCH}`, { empSearchString: searchText });
//     };

//     const defns = {
//         searchInput: {
//             placeholder,
//             value: searchText,
//             // onChange: handleChangeSearchBox,
//             // onKeyPress: handlePressKey,
//             onClick: handleClickSearchBox,
//         },
//         searchIcon: {
//             // onClick: handleClickSearchIcon,
//         },
//     };
//     setClassNameInDefns(defns, classes);

//     return (
//         // <div {...defns.searchBoxContainer}>
//         //     <InputBase inputProps={{ 'aria-label': 'search' }} {...defns.searchInput} startAdornment={<SearchIcon {...defns.searchIcon} />} />
//         // </div>
//         <div className={classes.searchContainer}>
//             <InputBase
//                 startAdornment={
//                     <InputAdornment position="start" {...defns.searchBoxIcon}>
//                         <AfitdIconButton {...defns.searchIconBtn}>
//                             <SearchOutlinedIcon />
//                         </AfitdIconButton>
//                     </InputAdornment>
//                 }
//                 // <SearchIcon {...defns.searchBoxIcon} />
//                 classes={{
//                     root: classes.inputRoot,
//                     input: classes.inputInput,
//                 }}
//                 inputProps={{ 'aria-label': 'search' }}
//                 {...defns.searchInput}
//             />
//         </div>
//     );
// };

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const TopNavJs = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    const appContext = useContext(AppContext);
    const { emailVerified, pendingAccountSetup, setPendingAccountSetupMessageDialogOpen, tempSwitchUser, currentUser } = appContext;

    const layoutContext = useContext(LayoutContext);
    const { dashboardData } = layoutContext;
    const history = useHistory();
    const location = useLocation();

    const theme = useTheme();
    const xlMatchesUp = useMediaQuery(theme.breakpoints.up('xl'));
    const mdMatches = useMediaQuery(theme.breakpoints.down('md'));
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));

    const email = _get(currentUser, 'email');
    const fullName = getFullNameMiddleInitialByUser(currentUser);
    // END OF temp switch user

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [tempAnchorEl, setTempAnchorEl] = useState();
    const [tempMenuHidden, setTempMenuHidden] = useState(false);
    const [, setAvatarMenuAnchorEl] = useState();

    // pop over section state and handler
    const [anchorEl, setAnchorEl] = React.useState(null);
    // const handleOpenProfilePopOver = event => {
    //     setAnchorEl(event.currentTarget);
    // };
    const handleCloseProfilePopOver = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    // drawer state and handler
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const handleDrawerOpen = () => {
        setOpenDrawer(true);
    };

    const handleDrawerClose = () => {
        setOpenDrawer(false);
    };

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const manageAccountBtnIsHidden = !emailVerified || pendingAccountSetup;

    // Calculating Total unread notifications count
    const unreadMessagesCounts = _get(dashboardData, 'unreadMsgsCounts', {}); // Object
    const actionNeededPendingInterviews = _get(dashboardData, 'actionNeededPendingInterviews', []); // array
    const unreadDeclinedInterviews = _get(dashboardData, 'unreadDeclinedInterviews', []); // array
    let totalUnreadMessageCount = [];
    if (unreadMessagesCounts) {
        totalUnreadMessageCount = Object.keys(unreadMessagesCounts).map(function (key, index) {
            return unreadMessagesCounts[key];
        });
    }

    totalUnreadMessageCount = totalUnreadMessageCount.reduce((a, b) => a + b, 0);
    const totalUnreadNotificationsCount = totalUnreadMessageCount + actionNeededPendingInterviews?.length + unreadDeclinedInterviews?.length;

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // ? closing Drawer if switch between mobile/Tab to desktop view
    useEffect(() => {
        if (!mdMatches && !smMatches) setOpenDrawer(false);
    }, [smMatches, mdMatches]);

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleClickLogo = useCallback(() => {
        history.push(`${BASE_URL}${PATH_HOME}`);
    }, [history]);

    const handleClickProfilePic = useCallback(evt => {
        setAvatarMenuAnchorEl(evt.currentTarget);
        setAnchorEl(evt.currentTarget);
    }, []);

    const handleClickPopoverProfilePic = useCallback(evt => {
        setAvatarMenuAnchorEl(evt.currentTarget);
        setAnchorEl(evt.currentTarget);
    }, []);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    if (props.isHidden) return null;
    const defns = getDefns({
        props,
        classes,
        appContext,
        handleClickLogo,
        handleClickProfilePic,
        handleClickPopoverProfilePic,
        history,
        setPendingAccountSetupMessageDialogOpen,
        location,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.topNavContainer}>
            <Grid {...defns.topNavLeft}>
                {mdMatches ? null : (
                    <AfitdBox {...defns.appLogoContainer}>
                        <span {...defns.appLogoHomeLink}>
                            <Logo {...defns.appLogo} />
                        </span>
                    </AfitdBox>
                )}
                {mdMatches ? (
                    openDrawer ? (
                        /* ------------------ 0 - 1023 (drawer opened) ------------------ */
                        <Grid {...defns.logoDrawerContainer}>
                            <div {...defns.drawerIconContainer}>
                                <CloseIcon onClick={handleDrawerClose} {...defns.closeBarIcon} />
                            </div>

                            <div {...defns.appLogoHomeLink}>
                                <LogoSm {...defns.appLogo} />
                            </div>
                        </Grid>
                    ) : (
                        /* ------------------ 0 - 1023 (drawer closed) ------------------ */
                        <Grid {...defns.logoDrawerContainer}>
                            <div {...defns.drawerIconContainer}>
                                <MenuIcon onClick={handleDrawerOpen} {...defns.menuBarIcon} />
                            </div>

                            <div {...defns.appLogoHomeLink}>
                                <LogoSm {...defns.appLogo} />
                            </div>
                        </Grid>
                    )
                ) : null}
            </Grid>
            <Grid {...defns.topNavRight}>
                <div {...defns.topNavRightContainer}>
                    {/* ------------------ Temporary EmpSearch button ------------------ */}
                    {/* <AfitdBox {...defns.empSearchContainer}>
                        <SearchBox {...defns.empSearchBox} />
                    </AfitdBox> */}
                    {/* --------------- END OF Temporary EmpSearch button --------------- */}

                    {/* --------------- My Dashboard 1024 up--------------- */}
                    {mdMatches ? null : <DashboardPopover />}

                    {/* back to resourceCenterButton md down hide */}
                    {mdMatches ? null : (
                        <AfitdBox {...defns.resourceCenterButtonContainer}>
                            <TopNavButton {...defns.resourceCenterButton} />
                        </AfitdBox>
                    )}

                    {/* ------------------ Temporary Switch User button ------------------ */}
                    {xlMatchesUp && process.env.REACT_APP_ENV !== 'PROD' && !tempMenuHidden && (
                        <div {...defns.tempMenuButtonContainer}>
                            <TopNavButton
                                onClick={evt => {
                                    setTempAnchorEl(evt.currentTarget);
                                }}
                                label="TEMP"
                            />
                            <Menu
                                id="simple-menu"
                                anchorEl={tempAnchorEl}
                                keepMounted
                                open={Boolean(tempAnchorEl)}
                                onClose={() => {
                                    setTempAnchorEl(null);
                                }}
                            >
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('entero_it_solutions');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Entero IT Solutions (Tier 3)
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('dairy_queen_1');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Dairy Queen (Tier 1)
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('coaching_prospects_2');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Coaching Prospects (Tier 2)
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('american_painting_2');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to American Painting (Tier 2)
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('s4_construction_3');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to S4 Construction (Tier 3)
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('tesla_3');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Tesla (Tier 3)
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('chicago_bulls');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Chicago Bulls (Tier 3)
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('chipotle');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Chipotle (Tier 2)
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('six_flags_america');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Six Flags America (Tier 3)
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('michael_jordan');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Michael Jordan
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('tom_clancy');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Tom Clancy
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('john_ramsey');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to John Ramsey
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('tina_nickel');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Tina Nickel
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('sheri_smith');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Sheri Smith
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('shelly_knolls');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Shelly Knolls
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('horace_grant');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Horace Grant
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('scottie_pippen');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Scottie Pippen
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('dennis_rodman');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Dennis Rodman
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('steve_kerr');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Steve Kerr
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        tempSwitchUser('dawn_small');
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Switch to Dawn Small
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        history.push(`${BASE_URL}${PATH_SURVEY}/HUSeSR9Io3Yl8nBmjBA4`);
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Survey JS
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        history.push(`${BASE_URL}${PATH_SURVEY}/TmjIzPuABf`);
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Survey EMP
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        history.push(`${BASE_URL}${PATH_JOIN_INTERVIEW}/${PATH_JOIN_INTERVIEW_TEST_JOIN_CODE}`);
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Join Interview
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        history.push(`${BASE_URL}${PRE_LAUNCH_PAGE}`);
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Pre-Launch Page
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        history.push(`${BASE_URL}${PATH_ADVERTISE}/intro`);
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Advertise With Us
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        history.push(`${BASE_URL}${PATH_ADMIN_CONSOLE}/${ADMIN_ID_JOB_SEEKER}`);
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Admin Console
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        setTempMenuHidden(true);
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Hide TEMP Menu
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        history.push(`${BASE_URL}/quick-admin/owSoenQPvcne888`);
                                        setTempAnchorEl(null);
                                    }}
                                >
                                    Temp Admin
                                </MenuItem>
                            </Menu>
                        </div>
                    )}
                    {/* ------------------ END OF Temporary Switch User button ------------------ */}
                    <AfitdBox {...defns.avatarContainer}>
                        {/* notification badge section */}
                        {mdMatches && totalUnreadNotificationsCount > 0 && (
                            <div {...defns.notificationBadgeContainer} onClick={handleDrawerOpen}>
                                <p {...defns.notificationBadge}>{totalUnreadNotificationsCount}</p>
                            </div>
                        )}
                        <AfitdAvatarWithRing {...defns.avatar} />

                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleCloseProfilePopOver}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                        >
                            <div {...defns.profilePopOverContainer}>
                                <div {...defns.closeIconContainerProfile}>
                                    <CloseIcon {...defns.closeIconContent} onClick={handleCloseProfilePopOver} />
                                </div>
                                <div {...defns.profileImage}>
                                    <AfitdAvatarWithRing {...defns.avatarPopover} />
                                </div>
                                <div {...defns.popoverContents}>
                                    <p {...defns.fullNameText}>{fullName} </p>
                                    <p {...defns.emailText}>{email} </p>
                                    <AfitdButton
                                        {...defns.manageAccountBtn}
                                        variant="containedSecondary"
                                        onClick={() => {
                                            handleCloseProfilePopOver();
                                            history.push(`${BASE_URL}/dashboard/1`);
                                            setAvatarMenuAnchorEl(null);
                                        }}
                                        isHidden={manageAccountBtnIsHidden}
                                    >
                                        Manage your Account
                                    </AfitdButton>
                                    {!manageAccountBtnIsHidden && <br />}

                                    <AfitdButton
                                        {...defns.logOutBtn}
                                        variant="contained"
                                        onClick={() => {
                                            appContext.setIsAuthenticationPending(true);
                                            appContext.auth.signOut();
                                            if (appContext?.setCurrentUser) {
                                                appContext.setCurrentUser(null);
                                            }
                                            setAvatarMenuAnchorEl(null);
                                            history.push(`${BASE_URL}${PATH_HOME}`, { isPromptLogin: true });
                                        }}
                                    >
                                        Log Out
                                    </AfitdButton>
                                    <p {...defns.privacyAndTermsText}>
                                        <span {...defns.privacyLink}>Privacy Policy</span> / <span {...defns.termsOfUseLink}>Terms of Use</span>
                                    </p>
                                </div>
                            </div>
                        </Popover>
                    </AfitdBox>
                </div>
            </Grid>

            {/* ================== bottom navbar for sm down ================== */}

            {/* {smMatches ? (
                <Grid {...defns.topNavBottomRight}>
                    <div {...defns.topNavBottomContainer}>
                        <AfitdBox>
                            <TopNavButtonBottom {...defns.dashboardButton} />
                        </AfitdBox>
                    </div>
                </Grid>
            ) : null} */}
            {/* ================== Drawer Section ================== */}
            {mdMatches && (
                /* ------------------ below 768 ------------------ */
                <div className={classes.root}>
                    <CssBaseline />
                    <AppBar position="fixed"></AppBar>
                    <Drawer
                        className={classes.drawer}
                        variant="persistent"
                        anchor="left"
                        open={openDrawer}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <TopNavJsSmallMenu handleDrawerClose={handleDrawerClose} />
                    </Drawer>
                </div>
            )}
        </Grid>
    );
};

export default TopNavJs;
